import { render, staticRenderFns } from "./ImageFlipper.vue?vue&type=template&id=4a036f3a&scoped=true&"
import script from "./ImageFlipper.vue?vue&type=script&lang=js&"
export * from "./ImageFlipper.vue?vue&type=script&lang=js&"
import style0 from "./ImageFlipper.vue?vue&type=style&index=0&id=4a036f3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a036f3a",
  null
  
)

export default component.exports